/* React */
import React from "react";

/* Ionic */
import { IonButton, IonIcon } from "@ionic/react";

/* Stylesheet */
import styles from "./PrimaryButton.module.scss";

/* Interfaces */
interface PrimaryButtonProps {
  testId?: string;
  scssProps?: ScssProps;
  type: "submit" | "button";
  ariaLabel: string;
  icon?: string;
  label: string;
  disabled?: boolean;
  onClick?: () => void;
}

interface ScssProps {
  margin?: string;
  marginLeft?: string;
  height?: string;
  width?: string;
  color?: string;
  backgroundColor?: string;
  icon?: IconProps;
}

interface IconProps {
  height?: string;
  width?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  testId,
  scssProps,
  type,
  ariaLabel,
  icon,
  label,
  disabled,
  onClick,
}) => {
  return (
    <IonButton
      data-cy={testId}
      style={{
        margin: scssProps?.margin,
        marginLeft: scssProps?.marginLeft,
        height: scssProps?.height,
        width: scssProps?.width,
        color: scssProps?.color,
        "--background": scssProps?.backgroundColor,
      }}
      className={styles.primary_button}
      type={type}
      aria-label={ariaLabel}
      expand="block"
      disabled={disabled}
      onClick={onClick}
    >
      {icon ? (
        <IonIcon
          style={{
            height: scssProps?.icon?.height,
            width: scssProps?.icon?.width,
          }}
          className={styles.icon}
          slot="start"
          icon={icon}
        />
      ) : undefined}
      <div
        style={{ color: scssProps?.color }}
        className={styles.label}
      >
        {label}
      </div>
    </IonButton>
  );
};

export default PrimaryButton;
